import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SuccessMessage, Title, Subtitle, ButtonWrapper, PrimaryButton } from '../styles';

interface SuccessViewProps {
  email: string;
}

const SuccessView: React.FC<SuccessViewProps> = ({ email }) => {
  const navigate = useNavigate();

  return (
    <>
      <SuccessMessage>
        <Title style={{ marginBottom: '8px' }}>Check Your Email</Title>
        <Subtitle style={{ marginBottom: '0' }}>
          We've sent a 6-digit reset code to <strong>{email}</strong>
        </Subtitle>
        <Subtitle style={{ marginTop: '8px', fontSize: '12px', color: 'inherit' }}>
          If you don't see the email, check your spam folder.
        </Subtitle>
      </SuccessMessage>
      
      <ButtonWrapper>
        <PrimaryButton
          type="primary"
          block
          onClick={() => navigate(`/reset-password-code?email=${encodeURIComponent(email || '')}`)}
        >
          Enter Reset Code
        </PrimaryButton>
      </ButtonWrapper>
    </>
  );
};

export default SuccessView;
